import React from 'react'
import { styled } from 'styled-components'
import BottomFrame from './BottomFrame'
import TopFrame from './TopFrame'
import TimerAnimations from './TimerAnimations'

export default function Frame(): React$Node {
	return (
		<Positioner>
			<TopFrame className="top" />
			<TimerAnimations className="centered top" />
			<BottomFrame className="bottom" />
		</Positioner>
	)
}

const Positioner = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	pointer-events: none;
	.centered {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}
	.top {
		position: absolute;
		top: 0;
	}

	.bottom {
		position: absolute;
		bottom: 0;
	}
	z-index: ${({ theme }) => theme.zTopOverlay};
`
